// Helpers for the dynamic form generator on PackageProduction.
//
// Each `overlays` row carries a `variables` JSON array describing the fields
// it consumes. PackageProduction renders one card per overlay from
// `overlay.variables` directly — duplicate keys across overlays are avoided
// at the data layer (migrations cleared overlapping schemas), not merged
// client-side. Values live in `package_state.state` keyed by the variable's
// `key` (dot-notation paths via getValueAtPath/setValueAtPath).

// Read a nested value out of an object via a dot-notation path.
// `getValueAtPath(state, 'tournament.name')` → state.tournament?.name
// Missing intermediate keys return undefined; never throws.
export function getValueAtPath(obj, path) {
  if (obj == null) return undefined;
  const parts = String(path).split('.');
  let cur = obj;
  for (const p of parts) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = cur[p];
  }
  return cur;
}

// Return a NEW object with the value at `path` replaced (immutably). Creates
// intermediate objects as needed. Doesn't mutate the input.
export function setValueAtPath(obj, path, value) {
  const parts = String(path).split('.');
  if (parts.length === 0) return obj;
  // Shallow-clone along the path; rest is shared with the input.
  const root = { ...(obj ?? {}) };
  let cur = root;
  for (let i = 0; i < parts.length - 1; i++) {
    const k = parts[i];
    const existing = cur[k];
    cur[k] = (existing && typeof existing === 'object' && !Array.isArray(existing))
      ? { ...existing }
      : {};
    cur = cur[k];
  }
  cur[parts[parts.length - 1]] = value;
  return root;
}

// Visual layout hint — half-width for short fields, full-width for the
// chunky / verbose ones (textarea, countdown).
export function colSpanForType(type) {
  switch (type) {
    case 'textarea':  return 'col-12';
    case 'countdown': return 'col-md-6';
    case 'boolean':   return 'col-md-6';
    case 'number':    return 'col-md-3';
    default:          return 'col-md-6'; // text, enum, url, etc.
  }
}
